import React from 'react';
import Clock from './Clock';
import Intensity0 from './Intensity0';
import Intensity1 from './Intensity1';
import Intensity2 from './Intensity2';
import Intensity3 from './Intensity3';
import Intensity4 from './Intensity4';
import Intensity5 from './Intensity5';
import Intensity6 from './Intensity6';
import Intensity7 from './Intensity7';
import Intensity8 from './Intensity8';
import Intensity9 from './Intensity9';
import Intensity10 from './Intensity10';

import Juice0 from './Juice0';
import Juice1 from './Juice1';
import Juice2 from './Juice2';
import Juice3 from './Juice3';
import Juice4 from './Juice4';
import Juice5 from './Juice5';

import SVG_PATH from './constants';
import Pie from './Pie';

export const TYPE = {
    CLOCK: 'clock',
    INTENSITY0: 'intensity-0',
    INTENSITY1: 'intensity-1',
    INTENSITY2: 'intensity-2',
    INTENSITY3: 'intensity-3',
    INTENSITY4: 'intensity-4',
    INTENSITY5: 'intensity-5',
    INTENSITY6: 'intensity-6',
    INTENSITY7: 'intensity-7',
    INTENSITY8: 'intensity-8',
    INTENSITY9: 'intensity-9',
    INTENSITY10: 'intensity-10',
    PIE0: 'pie-0',
    PIE10: 'pie-10',
    PIE20: 'pie-20',
    PIE25: 'pie-25',
    PIE30: 'pie-30',
    PIE50: 'pie-50',
    PIE60: 'pie-60',
    PIE70: 'pie-70',
    PIE75: 'pie-75',
    PIE80: 'pie-80',
    PIE90: 'pie-90',
    PIE100: 'pie-100',
    JUICE0: 'juice-0',
    JUICE1: 'juice-1',
    JUICE2: 'juice-2',
    JUICE3: 'juice-3',
    JUICE4: 'juice-4',
    JUICE5: 'juice-5'
};

export function getIcon(name, className) {
    switch (name) {
        case TYPE.CLOCK:
            return <Clock className={className} />;
        case TYPE.INTENSITY0:
            return <Intensity0 className={className} />;
        case TYPE.INTENSITY1:
            return <Intensity1 className={className} />;
        case TYPE.INTENSITY2:
            return <Intensity2 className={className} />;
        case TYPE.INTENSITY3:
            return <Intensity3 className={className} />;
        case TYPE.INTENSITY4:
            return <Intensity4 className={className} />;
        case TYPE.INTENSITY5:
            return <Intensity5 className={className} />;
        case TYPE.INTENSITY6:
            return <Intensity6 className={className} />;
        case TYPE.INTENSITY7:
            return <Intensity7 className={className} />;
        case TYPE.INTENSITY8:
            return <Intensity8 className={className} />;
        case TYPE.INTENSITY9:
            return <Intensity9 className={className} />;
        case TYPE.INTENSITY10:
            return <Intensity10 className={className} />;
        case TYPE.PIE0:
            return <Pie className={className} path={SVG_PATH.PIE0} />;
        case TYPE.PIE10:
            return <Pie className={className} path={SVG_PATH.PIE10} />;
        case TYPE.PIE20:
            return <Pie className={className} path={SVG_PATH.PIE20} />;
        case TYPE.PIE25:
            return <Pie className={className} path={SVG_PATH.PIE25} />;
        case TYPE.PIE30:
            return <Pie className={className} path={SVG_PATH.PIE30} />;
        case TYPE.PIE50:
            return <Pie className={className} path={SVG_PATH.PIE50} />;
        case TYPE.PIE60:
            return <Pie className={className} path={SVG_PATH.PIE60} />;
        case TYPE.PIE70:
            return <Pie className={className} path={SVG_PATH.PIE70} />;
        case TYPE.PIE75:
            return <Pie className={className} path={SVG_PATH.PIE75} />;
        case TYPE.PIE80:
            return <Pie className={className} path={SVG_PATH.PIE80} />;
        case TYPE.PIE90:
            return <Pie className={className} path={SVG_PATH.PIE90} />;
        case TYPE.PIE100:
            return <Pie className={className} path={SVG_PATH.PIE100} />;
        case TYPE.JUICE0:
            return <Juice0 className={className} />;
        case TYPE.JUICE1:
            return <Juice1 className={className} />;
        case TYPE.JUICE2:
            return <Juice2 className={className} />;
        case TYPE.JUICE3:
            return <Juice3 className={className} />;
        case TYPE.JUICE4:
            return <Juice4 className={className} />;
        case TYPE.JUICE5:
            return <Juice5 className={className} />;
        default:
            return <span>Icon Error!</span>;
    }
}



// WEBPACK FOOTER //
// ./src/lib/icons/SvgIcon.jsx